// Número oficial e único de WhatsApp da TaMoAki (confirmado pelo CEO a
// 06/10/2026). É onde o bot e o call center respondem. Não espalhar números
// pelo código: a página de Ajuda e um botão flutuante apontavam para números
// falsos (244900000000, 244123456789).
export const WHATSAPP_TAMOAKI = '244937777001';
export const WHATSAPP_TAMOAKI_LEGIVEL = '+244 937 777 001';

export function linkWhatsAppTaMoAki(texto?: string): string {
  const base = `https://wa.me/${WHATSAPP_TAMOAKI}`;
  return texto ? `${base}?text=${encodeURIComponent(texto)}` : base;
}

/** Mensagem inicial para quem prefere pedir o serviço por WhatsApp. */
export function linkPedidoWhatsApp(descricao?: string): string {
  const pedido = descricao?.trim();
  return linkWhatsAppTaMoAki(
    pedido
      ? `Olá TaMoAki! Preciso de um serviço: ${pedido}`
      // 21/10/2026: com campos a preencher — "Preciso de um serviço:" era muitas
      // vezes enviado assim mesmo, sem dizer o quê (o bot responde a isso com
      // uma pergunta fechada: admin, lib/atendimento/cliente-sem-resposta.ts).
      : 'Olá TaMoAki! Quero pedir um serviço.\nServiço: \nBairro: '
  );
}
